<div class='modal-body'>
  <div class='d-flex align-items-center justify-content-md-center mb-3'>
    <span id='close' class='close'>
      <img
        class='close-icon cursor-pointer'
        src='/assets/images/Cross2.png'
        alt=''
        (click)='hideModel(false)'
      />
    </span>
  </div>
  <div class='action--form'>
    <div class='form-details'>
      <h2 class='text-center fw-bold'>
        Are you sure you want to {{ !isActive ? 'deactivate' : 'activate' }} this creators?
      </h2>
      <div class='d-flex justify-content-center gap-2 flex-wrap'>
        <button class='btn-verify' (click)='hideModel(true)'>Confirm</button>
        <button class='btn-cancel' (click)='hideModel(false)'>Cancel</button>
      </div>
    </div>
  </div>
</div>
